import { definePropType } from "@types-vue/props";
import { computed, defineComponent, ref, watch } from "vue";
import { t } from "@/lang";
import PtButton from "@com/pt-components/pt-button/index.vue";
import { PtButtonType, PtButtonTheme } from "@com/pt-components/pt-button/enum";
export default defineComponent({
    components: {
        PtButton: PtButton
    },
    props: {
        title: {
            type: String,
            default: ""
        },
        loading: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            required: true
        },
        params: {
            type: definePropType(Object),
            required: true
        },
        rules: {
            type: definePropType(Array),
            required: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var schemaForm = ref();
        var model = ref({
            name: ""
        });
        var formConfig = ref({});
        var schema = computed(function() {
            return {
                type: "object",
                properties: {
                    name: {
                        component: "input",
                        class: "edit-project-name",
                        field: props.params,
                        rules: props.rules
                    }
                }
            };
        });
        var handleSubmit = function() {
            var _$ref;
            (_$ref = schemaForm.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function(valid) {
                if (valid) {
                    emit("submit", model.value["name"] || "");
                }
            });
        };
        var submitButton = {
            type: "primary",
            text: t("playTurbo.whole.confirm")
        };
        var cancelButton = {
            type: "plain",
            text: t("playTurbo.whole.cancel")
        };
        var closeDialog = function() {
            emit("update:visible", false);
        };
        var handleCancel = function() {
            closeDialog();
        };
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                model.value = {
                    name: props.value
                };
            }
        });
        return {
            schemaForm: schemaForm,
            model: model,
            schema: schema,
            formConfig: formConfig,
            submitButton: submitButton,
            cancelButton: cancelButton,
            PtButtonType: PtButtonType,
            PtButtonTheme: PtButtonTheme,
            handleSubmit: handleSubmit,
            handleCancel: handleCancel,
            closeDialog: closeDialog
        };
    }
});
